var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListItem',_vm._g(_vm._b({staticClass:"list-item-choose",class:{ active: _vm.active, checked: _vm.checked }},'ListItem',_vm.$attrs,false),_vm.$listeners),[_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }